import InlineMessage from '@ingka/inline-message';
import styles from './InlineErrorMessage.module.scss';

export type InlineErrorMessageProps = {
  body: string;
  title: string;
};

export const InlineErrorMessage: React.FC<InlineErrorMessageProps> = ({ body, title }) => {
  return (
    <div className={styles['container']}>
      <InlineMessage body={body} title={title} variant="negative" />
    </div>
  );
};
